import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function usePoliticianTransactions(id) {
  const { data, error, isLoading } = useSWRImmutable(`/react/politician-transactions?stock_id=${id}`, fetcher)

  return {
    politicianTransactions: data,
    isLoading,
    error
  }
}